/**
 * Хелперы отображения точек маршрута в распределении.
 *
 * Точка приходит в двух форматах (см. alt RoutePointAccord):
 *  - warehouse_name задан → имя точки = warehouse_name, адреса нет;
 *  - warehouse_name пуст → city_name = склейка «Имя, Российская Федерация, обл., город, улица, дом»:
 *    имя = голова до маркера страны, адрес = хвост после маркера.
 */

export const COUNTRY_MARKER = ', Российская Федерация';

/**
 * Чистое имя точки: warehouse_name, иначе голова city_name до маркера страны,
 * иначе весь city_name. Пустая строка → null.
 */
export function pointTitle(point) {
  if (!point) return null;
  if (point.warehouse_name) return point.warehouse_name;
  const city = typeof point.city_name === 'string' ? point.city_name : '';
  const idx = city.indexOf(COUNTRY_MARKER);
  const head = idx >= 0 ? city.slice(0, idx) : city;
  return head.trim() || null;
}

/**
 * Адрес точки: только когда warehouse_name пуст и в city_name есть маркер
 * страны — хвост после маркера. Иначе null (адреса нет).
 */
export function pointAddress(point) {
  if (!point) return null;
  if (point.warehouse_name) return null;
  const city = typeof point.city_name === 'string' ? point.city_name : '';
  const idx = city.indexOf(COUNTRY_MARKER);
  if (idx < 0) return null;
  return city.slice(idx + COUNTRY_MARKER.length).replace(/^,\s*/, '').trim() || null;
}

/**
 * Категория точки из points_registry карточки (позиционно параллелен точкам).
 * Возвращает 'top' | 'key' | 'regular' | null.
 */
export function pointRegistryCategory(pointsRegistry, index) {
  const info = Array.isArray(pointsRegistry) ? pointsRegistry[index] : null;
  return info ? info.category || null : null;
}

/**
 * Имя клиента справочника для точки (tooltip бейджа) либо null.
 */
export function pointRegistryName(pointsRegistry, index) {
  const info = Array.isArray(pointsRegistry) ? pointsRegistry[index] : null;
  return info ? info.client_name || null : null;
}

/**
 * Метка бейджа точки: 'ТОП' для top, 'КА' для key, null для regular/без матча.
 */
export function pointBadgeLabel(category) {
  if (category === 'top') return 'ТОП';
  if (category === 'key') return 'КА';
  return null;
}
